import { render, staticRenderFns } from "./F280.vue?vue&type=template&id=3ac4fe04&scoped=true"
import script from "./F280.vue?vue&type=script&lang=js"
export * from "./F280.vue?vue&type=script&lang=js"
import style0 from "./F280.vue?vue&type=style&index=0&id=3ac4fe04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac4fe04",
  null
  
)

export default component.exports